import _filter from 'lodash/filter';
import { CYOA_NETWORK_IDS } from '../config';

/**
* Calculate grand total for trip(s) including accommodation
* Used on - Payment stage
*
* @param {array} arr - Booking response
* @param {array} itineraries - Itineraries response
*/
export const calculateGrandTotal = (arr, itineraries) => {

  const hasCYO = _filter(arr, (o) => {return o.tour_id === CYOA_NETWORK_IDS["europe"].id || o.tour_id === CYOA_NETWORK_IDS["usa"].id})[0];

  let _grandTotal = 0;
  let _acommodationTotal = 0;

  if(hasCYO !== undefined && Object.keys(hasCYO).length > 0){

    for(let i = 0; i < arr.length; i++){
      for(let ii = 0; ii < arr[i].passengers.length; ii++){
        _grandTotal +=  arr[i].passengers[ii].price;
      }
    }

    if(itineraries !== ""){
      for(let i = 0; i < itineraries.sectors.length; i++){
        if(itineraries.sectors[i].accommodation.bookings !== undefined){
          _acommodationTotal +=  parseFloat(itineraries.sectors[i].accommodation.bookings.total);
        }
      }
    }


    //Note - for confirmed booking only show grand total
    return (itineraries.status !== "confirmed") ? (_grandTotal + _acommodationTotal).toFixed(2) : itineraries.grand_total;

  }else{

    for(let i = 0; i < arr.length; i++){
      for(let ii = 0; ii < arr[i].passengers.length; ii++){
        _grandTotal +=  arr[i].passengers[ii].price;
      }
    }
    return _grandTotal.toFixed(2);

  }

}


/**
* Calculate accommodation price
*
* @param {array} arr - Itineraries response
*/
export const calculateAccommodationPrice = (arr) => {
  let _total = 0;
  for(let i = 0; i < arr.length; i++){
    if(arr[i].accommodation.bookings !== undefined){
      _total +=  parseFloat(arr[i].accommodation.bookings.total);
    }
  }
  return _total.toFixed(2);
}



// WEBPACK FOOTER //
// ./src/helpers/priceHelper.js